import React from 'react';
import { InformationTitle } from '../../CampaignDetails/CampaignDetails.styles';
import { CampaignType, ProgressProps } from './Progress.interface';
import {
    Container,
    FlexWrapper,
    StyledLinearProgress,
    CampaignName,
    Percent,
    Numbers,
    ShowAll,
    StyledLink
} from './Progress.styles';

export function Progress({ adminAccess, data }:ProgressProps) {
    const renderProgressBar = (e: CampaignType) => {      
        return (
            e.dovepointsLimit ?
                <StyledLink key={e.title} to={`${process.env.REACT_APP_INTERNAL_URL}campaign-details/${e.id}`}>
                    <FlexWrapper>
                            <>
                                <div>
                                    <CampaignName>{e.title}</CampaignName>
                                    <StyledLinearProgress variant="determinate" value={Math.floor(e.dovepointsUsed*100/e.dovepointsLimit)} />
                                    <Numbers>{e.dovepointsUsed}/{e.dovepointsLimit}</Numbers>
                                </div>
                                <div>
                                    <Percent>{Math.floor(e.dovepointsUsed*100/e.dovepointsLimit)}%</Percent>
                                </div>
                            </>
                    </FlexWrapper>
                </StyledLink>
                :
                    <StyledLink key={e.title} to={`${process.env.REACT_APP_INTERNAL_URL}campaign-details/${e.id}`}>
                        <div>
                            <CampaignName>{e.title}</CampaignName>
                            <Numbers>{e.dovepointsUsed}</Numbers>
                        </div>
                    </StyledLink>
        )
    }

    return (
        <Container>
            <InformationTitle>
                {adminAccess ? 'Best Performing Campaigns' : 'DovePoints usage for active Campaigns'}
            </InformationTitle>
            {data.map((campaign: CampaignType) => renderProgressBar(campaign))}
            <ShowAll to={`${process.env.REACT_APP_INTERNAL_URL}my-campaigns`}>Show all</ShowAll>
        </Container>
    )
}
